var map = {
	"./2024/autumn/poster/all_game.png": "eb4b",
	"./2024/summer/poster/all_game.png": "cb2c",
	"./2024/winter/poster/all_game.png": "5264",
	"./2025/spring/poster/all_game.png": "6e03",
	"./2025/summer/poster/all_game.png": "8d12",
	"./2025/winter/poster/all_game.png": "621a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6653";